export const EnumTipoServico = Object.freeze({
    InerenteOptativo: "InerenteOptativo",
    Complementar: "Complementar",
    Acessorio: "Acessorio",
    Diverso: "Diverso"
})